exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button{\n  color:white;\n  min-width: 150px;\n  background-color: #000000a1;\n  height: 2.5rem;\n  border-radius: 2rem;\n  font-weight: 400;\n  font-size: 0.8rem;\n  border: 0px;\n}\n", ""]);

// exports
